__turbopack_context__.v({
  "alertContainer": "SharingOptionsContent-module__6aNvIq__alertContainer",
  "alertText": "SharingOptionsContent-module__6aNvIq__alertText",
  "alertsWrapper": "SharingOptionsContent-module__6aNvIq__alertsWrapper",
  "facebook": "SharingOptionsContent-module__6aNvIq__facebook",
  "facebookMessenger": "SharingOptionsContent-module__6aNvIq__facebookMessenger",
  "imageSkeleton": "SharingOptionsContent-module__6aNvIq__imageSkeleton",
  "imageWrapper": "SharingOptionsContent-module__6aNvIq__imageWrapper",
  "modal": "SharingOptionsContent-module__6aNvIq__modal",
  "modalInner": "SharingOptionsContent-module__6aNvIq__modalInner",
  "open": "SharingOptionsContent-module__6aNvIq__open",
  "previewImage": "SharingOptionsContent-module__6aNvIq__previewImage",
  "sharingButtonsContainer": "SharingOptionsContent-module__6aNvIq__sharingButtonsContainer",
  "sharingButtonsWrapper": "SharingOptionsContent-module__6aNvIq__sharingButtonsWrapper",
  "socialSharingButton": "SharingOptionsContent-module__6aNvIq__socialSharingButton",
  "socialSharingButtonContainer": "SharingOptionsContent-module__6aNvIq__socialSharingButtonContainer",
  "whatsapp": "SharingOptionsContent-module__6aNvIq__whatsapp",
  "withImage": "SharingOptionsContent-module__6aNvIq__withImage",
});
